 
<script>
  import { panelController } from "../../../stores/service";
 /*  import Cropper from "svelte-easy-crop"; */
  import { onMount } from "svelte";
  import {
    dataViewRol,
    beginview,
    controlDatadmin,
    dataValid,
    controltableA,
  } from "../../../Controller/admin/config/ConfigRoles";
  import { user } from "../../../stores/user";

  onMount(async () => {
    if (!$dataViewRol.status) {
      beginview(
        JSON.parse(JSON.stringify($panelController)),
        JSON.parse(JSON.stringify($dataViewRol))
      );
    }
    document.title = "Ratingg | Roles";
  });



 
</script>


    


<div class="card">
  <div class="card-body">
    <div class="row text-center">
      <!-- <h3 class='text-sm text-md-lg'>{item.name}</h3>  -->
      <label for="title ">Crear usuarios</label>
    </div>
    <div class="row">
      <div class="form-group col-md-4">
        <label for="name">Nombre:</label>
        <input
          type="text"
          class="form-control"
          bind:value={$dataViewRol.inputs[0].value}
          on:input={() => {
            dataValid(
              "name",
              $dataViewRol.inputs[0].value,
              $panelController.service
            );
          }}
          disabled={$dataViewRol.inputs[0].active}
        />

        <p class={$dataViewRol.inputs[0].styletxt}>
          {$dataViewRol.inputs[0].messtxt}
        </p>
      </div>

      <div class="form-group col-md-4">
        <label for="email">Email:</label>
        <input
          type="text"
          class="form-control"
          bind:value={$dataViewRol.inputs[1].value}
          on:input={() => dataValid("email", $dataViewRol.inputs[1].value)}
          disabled={$dataViewRol.inputs[1].active}
        />

        <p class={$dataViewRol.inputs[1].styletxt}>
          {$dataViewRol.inputs[1].messtxt}
        </p>
      </div>

      <div class="form-group col-md-4">
        <label for="Rol">Modo:</label>
        <select
          class="form-select"
          aria-label="Default"
          bind:value={$dataViewRol.inputs[2].value}
          on:change={() => dataValid("rol", $dataViewRol.inputs[2].value)}
          disabled={$dataViewRol.inputs[2].active}
        >
          <option selected value={0}>Seleccione una opción</option>
          <option value={1}>Admin</option>
          <option value={2}>Usuario</option>
        </select>
        <p class={$dataViewRol.inputs[2].styletxt}>
          {$dataViewRol.inputs[2].messtxt}
        </p>
      </div>
    </div>

    <div class="row">
      <div class="d-grid gap-2 d-md-block">
        {#each $dataViewRol.btn as item, index}
          {#if item.status}
            <button
              class="btn {item.style} m-1"
              on:click={() => {
                controlDatadmin(
                  index,
                  JSON.parse(JSON.stringify($panelController)),
                  JSON.parse(JSON.stringify($dataViewRol))
                );
              }}
              >{item.text}
              <i class={item.ico}></i>
            </button>
          {/if}
        {/each}
        {#if $dataViewRol.carga}
          <div class="spinner-grow" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        {/if}
      </div>
    </div>
  </div>
</div>

<div class="card text-center">
  <div class="card-body">
    <div class="row center">
      <!-- <h3 class='text-sm text-md-lg'>{item.name}</h3>  -->
      <label for="title">Usuarios</label>
    </div>

    <div class="row">
      <div class="row">
        <!-- Dos campos numéricos -->
        <div class="row m-2">
          <table class="table table-sm table align-middle">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Usuario</th>
                <th scope="col">Email</th>
                <th scope="col">Fecha de registro</th>
                <th scope="col">Rol</th>
                <th scope="col">Acción</th>
              </tr>
            </thead>
            <tbody>
              {#if $panelController.service.tableadmins.length > 0}
                {#each $panelController.service.tableadmins as value, index}
                  <tr>
                    <th scope="row">{index + 1}</th>

                    <td>{value.name}</td>
                    <td>{value.email}</td>
                    <td>{value.date}</td>
                    <td>{value.admin ? "Administrador" : "Colaborador"}</td>

                    <td>
                      {#if value.admin && value.email == $user.email}
                        <button
                          type="button"
                          class="btn btn-outline-primary text-sm text-md-lg"
                          on:click={() => {
                            controltableA(
                              1,
                              index,
                              JSON.parse(JSON.stringify($panelController)),
                              JSON.parse(JSON.stringify($dataViewRol))
                            );
                          }}
                          >Editar
                          <i class="bi bi-pencil-square"></i>
                        </button>
                      {:else}
                        <button
                          type="button"
                          class="btn btn-outline-danger text-sm text-md-lg"
                          on:click={() => {
                            controltableA(
                              0,
                              index,
                              JSON.parse(JSON.stringify($panelController)),
                              JSON.parse(JSON.stringify($dataViewRol))
                            );
                          }}
                          >Eliminar
                          <i class="bi bi-trash"></i>
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-primary text-sm text-md-lg"
                          on:click={() => {
                            controltableA(
                              1,
                              index,
                              JSON.parse(JSON.stringify($panelController)),
                              JSON.parse(JSON.stringify($dataViewRol))
                            );
                          }}
                          >Editar
                          <i class="bi bi-pencil-square"></i>
                        </button>
                      {/if}
                    </td>
                  </tr>
                {/each}
              {/if}
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="card-footer text-body-secondary"></div>
  </div>
</div>

<style>
  /* Aplica un ancho máximo para la tabla */

  /* Agrega barras de desplazamiento horizontal si es necesario */
  @media screen and (max-width: 767px) {
    table {
      overflow-x: auto;
      display: block;
    }
  }
  .accordion-button:focus {
    box-shadow: none; /* Evita el resaltado al hacer clic */
  }
  .valid-c {
    color: green;
  }
  .valid-n {
    color: green;
  }
  .valid-i {
    color: red;
  }
  a {
    color: black;
  }
  .card {
    color: black;
  }
  .tx {
    text-align: center;
  }

  .widget-user-header {
    background-color: rgb(218, 92, 56);
    color: aliceblue;
  }
  .widget-user .widget-user-desc {
    margin-top: 6px !important ;
  }

</style>
